"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var baseClasses = [
    'br-inline-flex',
    'br-items-center',
    'br-uppercase',
    'br-shadow',
    'br-rounded-full',
    'br-text-center',
    'br-tracking-wide',
    'br-text-[.7em]',
    'br-font-bold',
    'br-leading-[1.4]',
    'br-px-[.9em]',
    'br-py-[.1em]',
    'br-top-[-.1em]',
    'br-relative'
];
var classesForPillType = {
    blue: ['br-bg-blue-600', 'br-text-white'],
    black: ['br-bg-gray-800', 'br-text-white'],
    green: ['br-bg-green-400', 'br-text-white'],
    red: ['br-bg-red-700', 'br-text-white'],
    yellow: ['br-bg-yellow-500', 'br-text-white'],
    orange: ['br-bg-orange-500', 'br-text-white'],
    'black-outline': ['br-bg-transparent', 'br-text-black', 'br-border', 'br-border-gray-800'],
    'green-outline': ['br-bg-transparent', 'br-border', 'br-border-green-400', 'br-text-green-400'],
    'orange-outline': ['br-bg-transparent', 'br-border', 'br-border-orange-500', 'br-text-orange-500'],
    'red-outline': ['br-bg-transparent', 'br-border', 'br-border-red-700', 'br-text-red-700'],
    'gray-outline': ['br-bg-transparent', 'br-border', 'br-border-gray-400', 'br-text-gray-700']
};
var Pill = function (_a) {
    var type = _a.type, _b = _a.marginX, marginX = _b === void 0 ? 'right' : _b, _c = _a.marginY, marginY = _c === void 0 ? 'bottom' : _c, className = _a.className, children = _a.children, unused = __rest(_a, ["type", "marginX", "marginY", "className", "children"]);
    return (React.createElement("div", __assign({ className: (0, classnames_1.default)(baseClasses, {
            'br-ml-[.5em]': marginX === 'left',
            'br-mr-[.5em]': marginX === 'right',
            'br-mt-[.5em]': marginY === 'top',
            'br-mb-[.5em]': marginY === 'bottom'
        }, classesForPillType[type], className) }, unused), children));
};
exports.Pill = Pill;
